
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categorias/[categoria]",
      function () {
        return require("private-next-pages/categorias/[categoria]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categorias/[categoria]"])
      });
    }
  